import React from 'react';
import ElevioProvider from 'elevio/lib/react';

import { ActiveStore } from 'ggApp/modules/store/selectors';
import loadConfiguration from 'ggApp/utils/configuration';
import { useTranslator } from 'ggApp/modules/translator';

const { ELEVIO_ACCOUNT_ID } = loadConfiguration();

const Elevio = ({ activeStore }: { activeStore: ActiveStore }) => {
    const { activeLanguage } = activeStore;
    const { t } = useTranslator();

    return (
        <ElevioProvider
            accountId={ELEVIO_ACCOUNT_ID}
            language={activeLanguage}
            settings={{
                hideLauncher: true,
                articleFeedbackEnabled: false,
            }}
            translations={{
                modules: {
                    customform: {
                        submit: t('TIPS_LINKS_CANCEL_SUBSCRIPTION_FORM_SUBMIT'),
                    },
                    support: {
                        thankyou: t('TIPS_LINKS_CANCEL_SUBSCRIPTION_FORM_SUBMIT_CONFIRMATION'),
                    },
                },
            }}
        />
    );
};

export default Elevio;
